<template>
  <div class="row">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Row',
};
</script>

<style scoped>
  .row {
    margin-right: -30px;
  }
  .row > * {
    padding: 0px;
    margin: 0px;
    padding-right: 15px;
    margin-bottom: 15px;
  }
</style>
